import { useEffect } from 'react';

interface SEOHeadProps {
  jsonLd?: object;
}

export default function SEOHead({ jsonLd }: SEOHeadProps) {
  useEffect(() => {
    if (jsonLd) {
      // Remove existing JSON-LD script if any
      const existingScript = document.querySelector('script[type="application/ld+json"]');
      if (existingScript) {
        existingScript.remove();
      }

      // Add new JSON-LD script
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(jsonLd);
      document.head.appendChild(script);

      return () => {
        // Cleanup on unmount
        const scriptToRemove = document.querySelector('script[type="application/ld+json"]');
        if (scriptToRemove) {
          scriptToRemove.remove();
        }
      };
    }
  }, [jsonLd]);

  return null;
}